import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core';
import { Dialog } from '@mui/material';
import { AppBar } from '@mui/material';
import { Toolbar } from '@mui/material';
import { IconButton } from '@mui/material';
import { Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Cancel';
import { Slide } from '@mui/material';
import PropTypes from 'prop-types';
import Styles from "../../assets/jss/psstyle/component/dialogStyle"

//  subDialog
import Inputtax from './Components/Inputtax'
import Inputtax1 from './Components/Inputtax1'
import PopUpMultipletax from './../../PopUp/PopUpMultipletax'
import Withholding from './Components/Withholding'
import IncomeWithholding from './Components/IncomeWithholding';
import APInvdebt from './Components/APInvdebt';
import APInvdebtpaybill from './Components/APInvdebtpaybill';
import Csprepayment from './Components/Csprepayment';
import Csapdeposit from './Components/Csapdeposit';
import PopUpSelSaleRetReqRef from './Components/PopUpSelSaleRetReqRef';
import PopUpSelSaleRetReqRefSub from './Components/PopUpSelSaleRetReqRefSub';
import Incometype from './Components/PopUpOther';
import Groupdataall from './Components/PopUpOther';
import SelAPDepositUse from './Components/SelAPDepositUse';
import Apcode from './Components/PopUpApcode'
import PopUpSaveMoneyExp from './../PopUpSaveMoneyExp'
import PopUpSearchPspayment from '../PopUpSearchPspayment'
const useStyles = makeStyles(Styles)

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog(props) {
    const classes = useStyles();
    const { title, parm, type, open } = props
    // const [resData, setresData] = useState()
    const handleClose = (e) => {
        //  console.log("rowStrAll",e);
        props.closeDialog(e[0])
        props.resData(e) //ส่งกลับข้อมูล
    }
    return (
        <div>
            <Dialog fullScreen open={open} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        {/* <IconButton edge="start" color="inherit" onClick={e=>handleClose(false)} aria-label="close">
                            <CloseIcon />
                        </IconButton> */}
                        <Typography variant="h6" className={classes.title}>
                            {title}
                        </Typography>
                        <IconButton edge="start" color="inherit" onClick={e => handleClose("")} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <div className={classes.container} style={{ maxWidth: '100%' }}>
                    <br></br>
                    {type === 'Inputtax' ? <Inputtax parm={parm} resdata={e => handleClose(e)} /> :
                        type === 'Inputmultipletax' ? <PopUpMultipletax parm={parm} resdata={e => { handleClose(e) }} /> :
                            type === 'TaxWithholding' ? <Withholding parm={parm} resdata={e => { handleClose(e) }} /> :
                                type === 'IncomeWithholding' ? <IncomeWithholding parm={parm} resdata={e => { handleClose(e) }} /> : ""}
                    {type === "Inputtax1" ? <Inputtax1 parm={parm} resdata={e => { handleClose(e) }} /> : ""}
                    {type === "Incometype" ? <Incometype parm={parm} resdata={e => { handleClose(e) }} /> : ""}
                    {type === "taxtype" ? <Incometype parm={parm} resdata={e => { handleClose(e) }} /> : ""}
                    {type === "Apcode" ? <Apcode parm={parm} resdata={e => { handleClose(e) }} /> : ""}
                    {type === "Apcode1" ? <Apcode parm={parm} resdata={e => { handleClose(e) }} /> : ""}
                    {type === "Groupdataall" ? <Groupdataall parm={parm} resdata={e => { handleClose(e) }} /> : ""}
                    {type === "APInvdebt" ? <APInvdebt parm={parm} resdata={e => { handleClose(e) }} /> : ""}
                    {type === "APInvdebtpaybill" ? <APInvdebt parm={parm} resdata={e => { handleClose(e) }} /> : ""}
                    {type === 'ARPaybill' ? <APInvdebtpaybill parm={parm} resdata={e => handleClose(e)} /> : ""}
                    {type === 'Csprepayment' ? <Csprepayment parm={parm} resdata={e => handleClose(e)} /> : ""}
                    {type === 'Csapdeposit' ? <Csapdeposit parm={parm} resdata={e => handleClose(e)} /> : ""}
                    {type === 'SelAPDepositUse' ? <SelAPDepositUse parm={parm} resdata={e => handleClose(e)} /> : ""}
                    {type === 'SelSaleRetReqRef' ? <PopUpSelSaleRetReqRef parm={parm} resdata={e => handleClose(e)} /> : ""}
                    {type === 'SelSaleRetReqRefSub' ? <PopUpSelSaleRetReqRefSub parm={parm} resdata={e => handleClose(e)} /> : ""}
                    {type === 'PopUpSearchPspayment' ? <PopUpSearchPspayment parm={parm} resdata={e => handleClose(e)} /> : ""}
                </div>
            </Dialog>
        </div>
    );
}
FullScreenDialog.prototype = {
    open: PropTypes.bool,
    title: PropTypes.string,
    parm: PropTypes.array,
    type: PropTypes.string
}